(() => {
 document.addEventListener('click', event => {
   const swatch=event.target.closest('[data-card-variant]');
   if(!swatch)return;
   const card=swatch.closest('[data-product-card]');
   card.querySelectorAll('[data-card-variant]').forEach(button=>button.setAttribute('aria-pressed',String(button===swatch)));
   card.querySelectorAll('[data-product-link]').forEach(link=>{link.href=swatch.dataset.url;});
   card.querySelector('[data-card-price]').textContent=swatch.dataset.price;
   const image=card.querySelector('img');image.src=swatch.dataset.image.trim();image.alt=swatch.dataset.name.trim()+' in '+swatch.dataset.color+', product view';
 });
 document.addEventListener('change',event=>{
   if(!event.target.matches('[data-variant-select]'))return;
   const select=event.target,option=select.selectedOptions[0],detail=select.closest('[data-product-detail]');
   detail.querySelector('[data-detail-price]').textContent=option.dataset.price;
   const image=detail.querySelector('[data-detail-image]');
   if(option.dataset.image.trim()){image.src=option.dataset.image.trim();image.alt=option.dataset.alt;}
   const available=option.dataset.available==='true';
   detail.querySelector('[data-add-button]').disabled=!available;
   detail.querySelector('[data-add-label]').textContent=available?'Add to cart':'Sold out';
   const quantity=detail.querySelector('[data-product-quantity]');quantity.value='1';
   if(option.dataset.max!=='')quantity.max=option.dataset.max;else quantity.removeAttribute('max');
   const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);
 });
})();
